import { ListItem as ChakraListItem } from '@chakra-ui/react';

type ListItemProps = React.ComponentProps<typeof ChakraListItem>;

const ListItem = ({ children, ...props }: Readonly<ListItemProps>) => {
  return <ChakraListItem {...props}>{children}</ChakraListItem>;
};

export default ListItem;
